export const P = {
  READ_PATIENT: 'read_patient',
  MANAGE_USERS: 'manage_users',
  READ_DOCUMENT: 'read_document',
  READ_TEMPLATE: 'read_template',

  CREATE_PATIENT: 'create_patient',
  UPDATE_PATIENT: 'update_patient',
  DELETE_PATIENT: 'delete_patient',
  SHARE_PATIENT: 'share_patient',
  READ_ENCOUNTER: 'read_encounter',

  UPDATE_DOCUMENT: 'update_document',
  EXPORT_DOCUMENT: 'export_document',
  UPLOAD_DOCUMENT: 'upload_document',
  CREATE_TEMPLATE: 'create_template',

  UPDATE_TEMPLATE: 'update_template',
  DELETE_TEMPLATE: 'delete_template',
  CREATE_ENCOUNTER: 'create_encounter',
  UPDATE_ENCOUNTER: 'update_encounter',

  DELETE_ENCOUNTER: 'delete_encounter',
  GENERATE_DOCUMENT: 'generate_document',
  MANAGE_ORGANIZATION: 'manage_organization',
  READ_UPLOADED_DOCUMENT: 'read_uploaded_document',
  UPDATE_UPLOADED_DOCUMENT: 'update_uploaded_document',
  DELETE_UPLOADED_DOCUMENT: 'delete_uploaded_document',
} as const;

export type PermissionName = (typeof P)[keyof typeof P];
